import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import RedCross from '../../../../../assets/images/module/general/RedCross.svg';
import { Checkbox, Group, Stack, TextInput } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import { NumberFormatBase, NumericFormat } from 'react-number-format';
import Autoload from '../../../../Autoload';
import { config } from '../../../../config/Setting';
import UtilityBillingAssignedIcon from '../../../SVGs/utilityBillingAssigned';
import SwitchContainer from '../SwitchContainer';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

export class DirectDebitConfirmationMessageModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    iban: '',
    ibanValidation: null,
    name: null,
    nameError: false,
    bankValidationFromFinApi: false,
    checkBoxConsent: false,
    bankInformation: null
  };
  
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    console.log('this.props.accountData: ', this.props.accountData);
    this.setState({name: this.props?.accountData?.addressCompany})
  }

  validateGermanIBAN=(iban)=> {
    // Remove spaces and make uppercase
    iban = iban.replace(/\s+/g, '').toUpperCase();
  
    // Check format and length
    const germanIbanRegex = /^DE\d{20}$/;
    if (!germanIbanRegex.test(iban)) {
      this.setState({ibanValidation: false});
    }
  
    // Rearrange IBAN: move first 4 chars to the end
    const rearranged = iban.slice(4) + iban.slice(0, 4);
  
    // Convert letters to numbers (A = 10, B = 11, ..., Z = 35)
    const converted = rearranged.replace(/[A-Z]/g, char =>
      (char.charCodeAt(0) - 55).toString()
    );
  
    // Perform mod-97 operation
    let remainder = converted;
    while (remainder.length > 9) {
      const part = remainder.slice(0, 9);
      remainder = (parseInt(part, 10) % 97).toString() + remainder.slice(9);
    }
  
    if(parseInt(remainder, 10) % 97 === 1){
      this.setState({ibanValidation: true}, ()=> this.bankSearch(iban));
    }else if(iban?.length > 0){
      this.setState({ibanValidation: false, bankValidationFromFinApi: false, bankInformation: null});
    }else{
      this.setState({ibanValidation: null, bankValidationFromFinApi: false, bankInformation: null});
    }
  }

  bankSearch=(iban)=>{
    if(iban.length > 0){
      Autoload.HttpRequestAxios.HttpRequest(
        config.financeApi + 'banks?search=' + iban+ '&fetch=10&offset='+0,
        'GET',
        null,
        null,
        false,
        true,
        false,
        this,
        'handleGetSearchBanks',
        {iban},
        false,
        '',
        {
          'Content-Type': 'application/json',
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    }
  }
  
  handleGetSearchBanks(response){
    if(response.status && response.statuscode === 200){
      if(response.result.length > 0){
        this.setState({bankValidationFromFinApi: true, ibanValidation: true, bankInformation: response.result[0]});
      }else{
        this.setState({bankValidationFromFinApi: false, ibanValidation: false, bankInformation: null});
      }
    }
  }

  validate=()=>{
    const { ibanValidation, name, bankValidationFromFinApi, checkBoxConsent, bankInformation } = this.state;
    return name?.length > 0 && (window.location.href.includes('app.') ? bankInformation?.bic?.length > 0 : true) && bankValidationFromFinApi && ibanValidation && checkBoxConsent;
  }
  
  render() {
    const { open, toggle, className, next, accountData } = this.props;
    const { iban, ibanValidation, name, nameError, bankValidationFromFinApi, checkBoxConsent, bankInformation, isMobile } = this.state;
    console.log('iban: ', iban);
    console.log('ibanValidation: ', ibanValidation);
    console.log('this.validate(): ', this.validate());
    return (
      <CustomModal
        heading={'Einrichtung des Lastschriftmandates'}
        headingClassName={'update-received-rent-modal-heading'}
        open={open}
        toggle={() => {
          toggle();
        }}
        className={`${className}`}
        style={{minWidth: !isMobile && '700px'}}
      >
        <Stack>
          <Stack>
            <Group><span className='add-allocation-sub-headings'>SEPA-Lastschriftmandat</span></Group>
            <p style={{fontFamily: 'Inter, sans-serif', fontWeight: '400', marginBottom: 0}}>Ich ermächtige die <span style={{fontWeight: 'bold'}}>Hello Housing GmbH, Heidestr. 34, 10557 Berlin (Zahlungsempfänger)</span>, fällige Gebühren zur Nutzung von hellohousing mittels Lastschrift bis auf Widerruf oder Kündigung des Abonnements von meinem Konto einzuziehen. Die Kündigung des Abonnements kann jederzeit direkt in hellohousing vorgenommen werden.</p>
            <p style={{fontFamily: 'Inter, sans-serif', fontWeight: '400', marginBottom: 0}}>Der Lastschrifteinzug erfolgt durch unseren Zahlungsdienstleister mollie.</p>
          </Stack>
          <Stack>
            <Group><span className='add-allocation-sub-headings'>Zahlungspflichtiger</span></Group>
            {/* <Group><span>Name des Zahlungspflichtigen (Kontoinhaber)</span></Group> */}
            <Group wrap="nowrap" align={'flex-start'}>    
              <TextInput
              placeholder="Name"
              label="Name des Zahlungspflichtigen (Kontoinhaber)"
              value={name}
              onChange={(event) => this.setState({name: event.currentTarget.value})}
              error={nameError && "Dieses Feld darf nicht leer sein."}
              required
              styles={{label: {whiteSpace: 'nowrap'}}}
              />
              <Stack gap={0} style={{width: '100%'}}>    
                <TextInput
                  label="IBAN des Zahlungspflichtigen (Kontoinhaber)"
                  required
                  styles={{
                    input: {
                      display: 'none'
                    }
                  }}
                />
                <Stack gap={0}>
                  <Group wrap="nowrap" gap={8}>
                    <NumberFormatBase
                    className={`form-control ${(iban.length > 0 && ibanValidation === false) && 'invalid'} direct-debit-iban-input`}
                    placeholder='DE## #### #### #### #### ##'
                    type="text"
                    format={(value) =>
                      value
                        .replace(/\s+/g, '')
                        .replace(/([a-z0-9]{4})/gi, '$1 ')
                        .trim()
                        .toLocaleUpperCase()
                    }
                    removeFormatting={(value) => value.replace(/\s+/gi, '')}
                    isValidInputCharacter={(char) => /^[a-z0-9]$/i.test(char)}
                    getCaretBoundary={(value) =>
                      Array(value.length + 1)
                        .fill(0)
                        .map((v) => true)
                    }
                    onValueChange={(values) => this.setState({iban: values.value.toLocaleUpperCase(), ibanValidation: values.value.length === 0 ? null : ibanValidation})}
                    onBlur={()=> this.validateGermanIBAN(iban)}
                    onKeyDown={(e) =>
                      !/^(?:[a-z0-9]|Backspace|Delete|Home|End|ArrowLeft|ArrowRight|Shift|CapsLock|Control|NumLock|Tab|Paste|Redo|Undo)$/i.test(
                        e.key,
                      ) && e.preventDefault()
                    }
                    />
                    {bankValidationFromFinApi ? UtilityBillingAssignedIcon('#5555FF') : UtilityBillingAssignedIcon('#9A9AB5')}
                  </Group>
                </Stack>
                {(iban.length > 0 && ibanValidation === false) && <span className='iban-error'>Die IBAN ist ungültig. Bitte überprüfen Sie Ihre Eingabe.</span>}
              </Stack>
            </Group>
            <Group wrap="nowrap" align={'flex-end'}>    
              <TextInput
              placeholder="Wird automatisch ermittelt"
              label="BIC (Kontoinhaber)"
              value={bankInformation?.bic}
              readOnly
              required
              //disabled={true}
              //onChange={(event) => this.setState({bic: event.currentTarget.value})}
              style={{minWidth: '285px'}}
              />
              {bankInformation &&
              <Stack className='direct-debit-bank-details-card selected-direct-debit-bank-details-card' align={'flex-start'} justify={'center'} gap={10}>
                <Group wrap="nowrap" gap={10}>
                  <img src={bankInformation?.iconUrl} alt='bank-icon' style={{width: '16px'}}/>
                  <span className='direct-debit-bank-name'>{bankInformation?.name}</span>
                </Group>
              </Stack>}
            </Group>
          </Stack>
          <Stack>
            <Group><span className='add-allocation-sub-headings'>Rücklastschriften</span></Group>
            <p style={{fontFamily: 'Inter, sans-serif', fontWeight: '400', marginBottom: 0}}>Sie haben das Recht innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages bei Ihrer Bank zu verlangen (Rücklastschrift).</p>
            <p style={{fontFamily: 'Inter, sans-serif', fontWeight: '400', marginBottom: 0}}>Bei Rücklastschriften entstehen Bank- und Abwicklungsgebühren i.H.v. derzeit 14,50 EUR. Mit Einrichtung des Lastschriftmandats, stimmen Sie zu, dass hellohousing diese Gebühren im Fall einer unberechtigten Rücklastschrift (z.B. durch fehlende Kontodeckung) weiterbelastet.</p>
            <p style={{fontFamily: 'Inter, sans-serif', fontWeight: '400', marginBottom: 0}}>Wenden Sie sich bei Fragen zu Abbuchungen von hellohousing Gebühren zunächst an den hellohousing Kundenservice (service@hellohousing.de), um unnötige Bankgebühren zu vermeiden.</p>
          </Stack>
          <Stack>
            <Group><span className='add-allocation-sub-headings'>Einrichtung des Lastschriftmandats</span></Group>
            <Checkbox
            checked={checkBoxConsent}
            onChange={()=> this.setState({checkBoxConsent: !checkBoxConsent})}
            label={<p style={{marginBottom: 0, fontFamily: 'Inter, sans-serif', lineHeight: 1.55}}>Ich bestätige, dass ich autorisiert bin, für das o.g. Konto ein Lastschriftmandat einzurichten und stimme der Einrichtung des Lastschriftmandates zu.<span style={{color: '#f03e3e', fontSize: '0.85rem'}}>*</span></p>}
            size={'xs'}
            classNames={{
              label: 'direct-debit-consent-checkbox'
            }}
            />
          </Stack>
          <Group justify="space-between" style={{marginTop: '20px'}}>
              <div>
                  <ColorButton
                  text={'Abbrechen'}
                  className='gray-btn'
                  onClick={()=> toggle()}
                  />
              </div>
              <div>
                  <ColorButton
                  text={'Zustimmen und fortfahren'}
                  className={`purple-btn ${!this.validate() && 'disabled'}`}
                  //disabled={!this.validate()}
                  onClick={()=> {
                    if(this.validate()){
                      next({consumerAccount: iban, consumerName: name, consumerBic: bankInformation?.bic});
                    }else{
                      showNotification({
                        message: 'Bitte vervollständigen Sie die notwendigen Informationen und stimmen Sie der Einrichtung des Lastschriftmandates zu.',
                        icon: <img src={RedCross} alt='red-cross'/>,
                        id: 'incompleteForError'
                      })
                    } 
                  }}
                  />
              </div>
          </Group>
        </Stack>
      </CustomModal>
    );
  }
}

export default DirectDebitConfirmationMessageModal;
